import Konva from 'konva';
import { useEffect, useRef } from 'react';
import { Line } from 'react-konva';
import { POLYGON_DASH, POLYGON_STROKE, POLYGON_STROKE_WIDTH } from './FlattenAreaPolygon';

const MARCH_SPEED = 35; // px/sec — same marching-ants feel as ThreeDFlattenAreaLoadingLayer

type Props = { points: number[] };

// Marching-ants outline for a loading shape — purely visual, click-blocking lives in FlattenAreaDrawer.
export default function FlattenAreaLoadingOutline({ points }: Props) {
	const lineRef = useRef<Konva.Line>(null);

	useEffect(() => {
		const line = lineRef.current;
		if (!line) return;
		const period = POLYGON_DASH[0] + POLYGON_DASH[1];
		const anim = new Konva.Animation((frame) => {
			if (!frame) return;
			line.dashOffset(-((frame.time / 1000) * MARCH_SPEED) % period);
		}, line.getLayer());
		anim.start();
		return () => { anim.stop(); };
	}, []);

	return (
		<Line
			ref={lineRef}
			points={points}
			stroke={POLYGON_STROKE}
			strokeWidth={POLYGON_STROKE_WIDTH}
			dash={POLYGON_DASH}
			strokeScaleEnabled={false}
			closed={true}
			listening={false}
		/>
	);
}
